import { render, staticRenderFns } from "./realTimeVideo.vue?vue&type=template&id=59516a0c&scoped=true&"
import script from "./realTimeVideo.vue?vue&type=script&lang=js&"
export * from "./realTimeVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59516a0c",
  null
  
)

export default component.exports